import { useMasterdataStore } from './useCommonStores'
import { useConfiguration } from './useConfiguration.pinia'
import { useI18n } from 'vue-i18n'

import uiUtils from '../helpers/uiUtils.pinia'

export function useUiUtils () {
  const masterdata = useMasterdataStore()
  const { brandConfig } = useConfiguration()
  const i18n = useI18n()

  uiUtils.setup({
    masterdata,
    brandConfig: brandConfig.value,
    i18n
  })

  const proxy = new Proxy(uiUtils, {
    get (target, symbol) {
      if (typeof target[symbol] === 'function') {
        return (...args) => target[symbol](...args)
      }
      return target[symbol]
    }
  })

  return proxy
}
